import { config } from '../../config';
import {
    ASSET_ENCODING_PERCENTAGE_SET,
    MEDIA_NODE_LIVE_STREAM_ENDED_SET,
    MEDIA_NODE_LIVE_STREAM_FIRST_CONNECTION_SET,
    MEDIA_NODE_LIVE_STREAM_STARTED_SET,
    SET_LIVE_STREAM_CONNECTION_ACTIVE,
    SET_MEDIA_NODE_PAGE_ACTIVE,
    SOCKET_ASSET_ENCODING_CONNECTION_CLOSE,
    SOCKET_ASSET_ENCODING_CONNECTION_ERROR,
    SOCKET_ASSET_ENCODING_CONNECTION_IN_PROGRESS,
    SOCKET_ASSET_ENCODING_CONNECTION_SUCCESS,
    SOCKET_ASSET_ENCODING_RECONNECTION_ERROR,
    SOCKET_CONNECTION_CLOSE,
    SOCKET_CONNECTION_ERROR,
    SOCKET_CONNECTION_IN_PROGRESS,
    SOCKET_CONNECTION_SUCCESS,
    SOCKET_LIVE_STREAM_CONNECTION_CLOSE,
    SOCKET_LIVE_STREAM_CONNECTION_ERROR,
    SOCKET_LIVE_STREAM_CONNECTION_IN_PROGRESS,
    SOCKET_LIVE_STREAM_CONNECTION_SUCCESS,
    SOCKET_LIVE_STREAM_RECONNECTION_ERROR,
    SOCKET_RECONNECTION_ERROR,
    TIMER_SET,
} from '../../constants/mediaNodes/socket';
import { init as socketInit, initLiveStream as socketInitLiveStream, initAssetEncoding as socketInitAssetEncoding } from '../../socket';
import { fetchLiveStreamStatusSuccess, streamPath } from './liveStream';
import { fetchTvLiveStreamUrlSuccess } from './tv';

const socketConnectionInProgress = () => {
    return {
        type: SOCKET_CONNECTION_IN_PROGRESS,
    };
};

const socketConnectionSuccess = (value, URL, address, nodeID, liveID) => {
    return {
        type: SOCKET_CONNECTION_SUCCESS,
        value,
        nodeUrl: URL,
        address,
        nodeID,
        liveID,
    };
};

const socketConnectionError = (message) => {
    return {
        type: SOCKET_CONNECTION_ERROR,
        message: 'Socket connection error',
    };
};

const socketConnectionClose = (message) => {
    return {
        type: SOCKET_CONNECTION_CLOSE,
        message,
    };
};

const socketReConnectionError = (message) => {
    return {
        type: SOCKET_RECONNECTION_ERROR,
        message,
    };
};

export const setMediaNodePageActive = (value) => {
    return {
        type: SET_MEDIA_NODE_PAGE_ACTIVE,
        value,
    };
};

export const setMediaNodeLiveStreamStarted = () => {
    return {
        type: MEDIA_NODE_LIVE_STREAM_STARTED_SET,
    };
};

export const setMediaNodeLiveStreamEnded = (value) => {
    return {
        type: MEDIA_NODE_LIVE_STREAM_ENDED_SET,
        value,
    };
};

export const setMediaNodeLiveFirstConnection = (value) => {
    return {
        type: MEDIA_NODE_LIVE_STREAM_FIRST_CONNECTION_SET,
        value,
    };
};

const checkMessages = (socket, dispatch, getState, cb) => {
    socket.onmessage = (message) => {
        const data = JSON.parse(message.data);

        const state = getState();
        const firstConnection = state?.socket?.socket?.firstConnection;
        const mediaNode = state?.mediaNode?.mediaNodeDetails?.value;
        const liveStream = state?.mediaNode?.liveStream?.streamDetails?.value;
        switch (data.type) {
        case 'live_stream_started': {
            if (cb) {
                cb(data);
            }
            dispatch(setMediaNodeLiveStreamStarted());
            if (mediaNode && mediaNode.url && liveStream && liveStream._id && mediaNode._id) {
                dispatch(streamPath(mediaNode?.url, liveStream?._id, mediaNode?._id));
            }
            // setTimeout(() => {
            //     dispatch(fetchLiveStreamStatusSuccess(data));
            // }, 10000);
            return null;
        }
        case 'live_stream_ended': {
            if (cb) {
                cb(data);
            }
            dispatch(setMediaNodeLiveStreamEnded(true));
            return null;
        }
        default: {
            if (cb) {
                cb(data);
            }

            if (firstConnection) {
                return null;
            }

            dispatch(fetchLiveStreamStatusSuccess(data));
            return null;
        }
        }
    };
};

export const createSocketConnection = (URL, address, nodeID, liveID, cb) => (dispatch, getState) => {
    const state = getState();
    if (!state?.socket?.socket?.active) {
        if (state?.socket?.socket?.connection) {
            state.socket.socket.connection.close();
        }

        return;
    }

    dispatch(socketConnectionInProgress());

    const url = `${URL}/ws/`;
    socketInit(url, address, nodeID, liveID, (error, close, socket) => {
        if (error) {
            console.log('web socket error', error);
            dispatch(socketConnectionError(error));
        } else if (close) {
            console.log('web socket closed', close.reason);
            dispatch(socketConnectionClose(close.reason));
            if (state?.socket?.socket?.active) {
                dispatch(createSocketConnection(URL, address, nodeID, liveID, cb));
            }
        } else {
            console.log('web socket connected');
            checkMessages(socket, dispatch, getState, cb);
            dispatch(socketConnectionSuccess(socket, URL, address, nodeID, liveID));
        }
    });
};

export const reconnect = (URL, address, nodeID, liveID) => (dispatch) => {
    const url = `${URL}/ws`;
    socketInit(url, address, nodeID, liveID, (error, close, socket) => {
        if (error) {
            dispatch(socketReConnectionError(error));
        } else if (close) {
            dispatch(socketConnectionClose(close.reason));
        } else {
            checkMessages(socket, dispatch);
            dispatch(socketConnectionSuccess(socket, URL, address, nodeID, liveID));
        }
    });
};

export const setTimer = (value) => {
    return {
        type: TIMER_SET,
        value,
    };
};

// Live stream page socket
const socketLiveStreamConnectionInProgress = () => {
    return {
        type: SOCKET_LIVE_STREAM_CONNECTION_IN_PROGRESS,
    };
};

const socketLiveStreamConnectionSuccess = (value, liveStreamID, clientID) => {
    return {
        type: SOCKET_LIVE_STREAM_CONNECTION_SUCCESS,
        value,
        liveStreamID,
        clientID,
    };
};

const socketLiveStreamConnectionError = (message) => {
    return {
        type: SOCKET_LIVE_STREAM_CONNECTION_ERROR,
        message: 'Socket connection error',
    };
};

const socketLiveStreamConnectionClose = (message) => {
    return {
        type: SOCKET_LIVE_STREAM_CONNECTION_CLOSE,
        message,
    };
};

const socketLiveStreamReConnectionError = (message) => {
    return {
        type: SOCKET_LIVE_STREAM_RECONNECTION_ERROR,
        message,
    };
};

export const setLiveStreamMediaNodePageActive = (value) => {
    return {
        type: SET_LIVE_STREAM_CONNECTION_ACTIVE,
        value,
    };
};

const checkMessagesLiveStream = (socket, dispatch, cb) => {
    socket.onmessage = (message) => {
        const data = JSON.parse(message.data);

        if (data) {
            if (cb) {
                cb(data);
            }

            if (data.type === 'live_stream_ended') {
                return;
            }
            dispatch(fetchTvLiveStreamUrlSuccess(data));
        }
    };
};

export const createSocketLiveStreamConnection = (liveStreamID, clientID, cb) => (dispatch, getState) => {
    const state = getState();
    if (!state?.socket?.socketLiveStream?.active) {
        if (state?.socket?.socketLiveStream?.connection) {
            state.socket.socketLiveStream.connection.close();
        }

        return;
    }

    dispatch(socketLiveStreamConnectionInProgress());

    socketInitLiveStream(config.LIVE_STREAM_WEB_SOCKET_URL, liveStreamID, clientID, (error, close, socket) => {
        if (error) {
            console.log('web socket error', error);
            dispatch(socketLiveStreamConnectionError(error));
        } else if (close) {
            console.log('web socket closed', close.reason);
            dispatch(socketLiveStreamConnectionClose(close.reason));
            if (state?.socket?.socketLiveStream?.active) {
                dispatch(createSocketLiveStreamConnection(liveStreamID, clientID, cb));
            }
        } else {
            console.log('web socket connected');
            checkMessagesLiveStream(socket, dispatch, cb);
            dispatch(socketLiveStreamConnectionSuccess(socket, liveStreamID, clientID));
        }
    });
};

export const reconnectLiveStream = (liveStreamID, clientID) => (dispatch) => {
    socketInitLiveStream(config.LIVE_STREAM_WEB_SOCKET_URL, liveStreamID, clientID, (error, close, socket) => {
        if (error) {
            dispatch(socketLiveStreamReConnectionError(error));
        } else if (close) {
            dispatch(socketLiveStreamConnectionClose(close.reason));
        } else {
            checkMessagesLiveStream(socket, dispatch);
            dispatch(socketLiveStreamConnectionSuccess(socket, liveStreamID, clientID));
        }
    });
};

// Asset Encoding socket
const socketAssetEncodingConnectionInProgress = () => {
    return {
        type: SOCKET_ASSET_ENCODING_CONNECTION_IN_PROGRESS,
    };
};

const socketAssetEncodingConnectionSuccess = (value, address, assetId) => {
    return {
        type: SOCKET_ASSET_ENCODING_CONNECTION_SUCCESS,
        value,
        address,
        assetId,
    };
};

const socketAssetEncodingConnectionError = (message) => {
    return {
        type: SOCKET_ASSET_ENCODING_CONNECTION_ERROR,
        message: 'Socket connection error',
    };
};

const socketAssetEncodingConnectionClose = (message) => {
    return {
        type: SOCKET_ASSET_ENCODING_CONNECTION_CLOSE,
        message,
    };
};

const socketAssetEncodingReConnectionError = (message) => {
    return {
        type: SOCKET_ASSET_ENCODING_RECONNECTION_ERROR,
        message,
    };
};

export const setAssetEncodingConnectionActive = (value, address, assetId) => {
    return {
        type: SOCKET_ASSET_ENCODING_CONNECTION_SUCCESS,
        value,
        address,
        assetId,
    };
};

const checkMessagesAssetEncoding = (socket, dispatch, cb) => {
    socket.onmessage = (message) => {
        const data = JSON.parse(message.data);

        if (data) {
            if (cb) {
                cb(data);
            }

            if (data?.percentage) {
                dispatch(setAssetEncodingPercentage(data));
            }
        }
    };
};

export const setAssetEncodingPercentage = (value) => {
    return {
        type: ASSET_ENCODING_PERCENTAGE_SET,
        value,
    };
};

export const createSocketAssetEncodingConnection = (URL, address, assetId, cb) => (dispatch) => {
    dispatch(socketAssetEncodingConnectionInProgress());

    const url = `${URL}/ws/`;
    socketInitAssetEncoding(url, address, assetId, (error, close, socket) => {
        if (error) {
            console.log('web socket error', error);
            dispatch(socketAssetEncodingConnectionError(error));
        } else if (close) {
            console.log('web socket closed', close.reason);
            if (socket) {
                socket.onmessage = (message) => {
                    const data = JSON.parse(message.data);

                    if (data) {
                        if (cb) {
                            cb(data);
                        }

                        if (data?.percentage) {
                            dispatch(createSocketAssetEncodingConnection(url, address, assetId, cb));
                        }
                    }
                };
            }
            dispatch(socketAssetEncodingConnectionClose(close.reason));
        } else {
            console.log('web socket connected');
            checkMessagesAssetEncoding(socket, dispatch, cb);
            dispatch(socketAssetEncodingConnectionSuccess(socket, address, assetId));
        }
    });
};

export const reconnectAssetEncoding = (URL, address, assetId) => (dispatch) => {
    const url = `${URL}/ws/`;
    socketInitAssetEncoding(url, address, assetId, (error, close, socket) => {
        if (error) {
            dispatch(socketAssetEncodingReConnectionError(error));
        } else if (close) {
            dispatch(socketAssetEncodingConnectionClose(close.reason));
        } else {
            checkMessagesAssetEncoding(socket, dispatch);
            dispatch(socketAssetEncodingConnectionSuccess(socket, address, assetId));
        }
    });
};
